import { useScrollContext } from "@pathwright/ui/src/components/scroll/ScrollView"
import { usePaginator } from "@pathwright/utils"
import get from "lodash/get"
import PropTypes from "prop-types"
import { useEffect } from "react"
import { useActivityQuery } from "@pathwright/graphql-client/src/generated"
import { flattenEdges } from "../utils/apollo"
import ActivityTimeline from "./ActivityTimeline"
import { LEARNING_ACTION_QUERY_FILTERS } from "./constants"

// component concerns:
// - describe query and set query variables from props
// - map query data to props
// - abstract and contain pagination logic

const ActivityContainer = (props) => {
  const activityQuery = useActivityQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      action_type: LEARNING_ACTION_QUERY_FILTERS[props.actionType]
        ? JSON.parse(LEARNING_ACTION_QUERY_FILTERS[props.actionType])
        : null,
      resource_id: props.resourceId,
      group_id: props.groupId,
      step_id: props.stepId,
      user_id: props.userId,
      include_user: !!props.userId
    },
    notifyOnNetworkStatusChange: true
  })

  const { error, loading, refetch } = activityQuery

  const activity_user = activityQuery.data?.activity_user
  const activity = flattenEdges(get(activityQuery.data, "activity"))
  const pageInfo = get(activityQuery.data, "activity.pageInfo")

  const paginator = usePaginator({
    query: activityQuery,
    paginatorValue: activityQuery.data?.activity
  })

  const { hasMore, loadingMore } = paginator

  useEffect(() => {
    // force refetch if mounting w/ cached data
    if (activity && pageInfo) {
      refetch()
    }
  }, [])

  const loadMore = () => !loadingMore && hasMore && paginator.loadMore()

  const scrollContext = useScrollContext()
  scrollContext &&
    scrollContext.useScroll({
      onScrollBottom: loadMore
    })

  return (
    <ActivityTimeline
      {...props}
      {...paginator}
      loadMore={loadMore}
      error={error}
      loading={loading}
      refetch={refetch}
      activity_user={activity_user}
      activity={activity}
    />
  )
}

ActivityContainer.displayName = "ActivityContainer"

ActivityContainer.propTypes = {
  actionType: PropTypes.string,
  resourceId: PropTypes.number,
  groupId: PropTypes.number,
  stepId: PropTypes.number,
  userId: PropTypes.number
}

export default ActivityContainer
